import { useFormik } from 'formik';
import { useCallback } from 'react';
import { plainToModel } from './plain.model';
import { useValidateFormik } from './validation';
export function useFormikModel(model, { initialValues, onSubmit, ...config }) {
    const validate = useValidateFormik(model);
    const handleSubmit = useCallback(async (data, formikHelpers) => {
        const resultModel = plainToModel(model, data);
        onSubmit(resultModel, formikHelpers);
    }, [model, onSubmit]);
    const props = {
        validate,
        onSubmit: handleSubmit,
        initialValues,
        validateOnBlur: false,
        validateOnChange: false,
        enableReinitialize: false,
        validateOnMount: false,
        ...config,
    };
    return useFormik(props);
}
